import { send } from 'server';

export const fetchUserNickname = () => send({
    ID: 31082,
    responses: [31083, 31084], // 31083 (success), 31084 (error)
    requestedPlayerData: [172], // casinoNickname (string)
    requestType: 'marked',
    description: 'Get users casino nickname'
});

export const setUserNickname = (nickname = '') => send({
    ID: 33045,
    responses: [31008, 33006], // 31008 (success), 33006 (error)
    dataMap: { casinoNickname: nickname },
    requestType: 'marked',
    description: 'Set users casino nickname'
});
